import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/alert/style";
import _Alert from "antd/lib/alert";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from 'react';
import Text from 'antd/lib/typography/Text';
import { runGem2s } from 'redux/actions/pipeline';
import { useDispatch, useSelector } from 'react-redux';
import { discardChangedQCFilters } from 'redux/actions/experimentSettings';
import { cloneExperiment } from 'redux/actions/experiments';
import { useAppRouter } from 'utils/AppRouteProvider';
import { modules } from 'const';
var texts = {
  qcTooOld: __jsx(React.Fragment, null, "Due to a recent update, re-running the pipeline will initiate the run from the beginning and you will lose all of your annotated cell sets. You have 3 options:"),
  runQCNotAuthorized: __jsx(React.Fragment, null, "Your account is not authorized to run data processing on this project. You have 2 options:")
};
var QCRerunDisabledModal = function QCRerunDisabledModal(props) {
  var experimentId = props.experimentId,
    onFinish = props.onFinish,
    visible = props.visible,
    runQCAuthorized = props.runQCAuthorized;
  var dispatch = useDispatch();
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var experimentName = useSelector(function (state) {
    return state.experimentSettings.info.experimentName;
  });
  var triggerOnRunGem2s = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(runGem2s(experimentId));
          case 2:
            onFinish();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function triggerOnRunGem2s() {
      return _ref.apply(this, arguments);
    };
  }();
  var cloneExperimentAndSelectIt = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var newExperimentId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onFinish();
            dispatch(discardChangedQCFilters());
            _context2.next = 4;
            return dispatch(cloneExperiment(experimentId, "Clone of ".concat(experimentName)));
          case 4:
            newExperimentId = _context2.sent;
            navigateTo(modules.DATA_MANAGEMENT, {
              experimentId: newExperimentId
            }, true);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function cloneExperimentAndSelectIt() {
      return _ref2.apply(this, arguments);
    };
  }();
  return __jsx(_Modal, {
    title: "Run data processing with the changed settings",
    open: visible,
    onCancel: function onCancel() {
      return onFinish();
    },
    footer: [].concat(_toConsumableArray(runQCAuthorized ? [__jsx(_Button, {
      type: "primary",
      onClick: function onClick() {
        return triggerOnRunGem2s();
      }
    }, "Start")] : []), [__jsx(_Button, {
      type: "primary",
      onClick: function onClick() {
        return cloneExperimentAndSelectIt();
      }
    }, "Clone Project"), __jsx(_Button, {
      onClick: function onClick() {
        return onFinish();
      }
    }, "Cancel")])
  }, __jsx(_Alert, {
    type: "warning",
    description: __jsx(React.Fragment, null, __jsx("p", null, runQCAuthorized ? texts.qcTooOld : texts.runQCNotAuthorized), __jsx("ul", null, runQCAuthorized && __jsx("li", null, "Click", __jsx(Text, {
      code: true
    }, "Start"), ' ', "to re-run this project analysis from the beginning. Note that you will lose all of your annotated cell sets."), __jsx("li", null, "Click", __jsx(Text, {
      code: true
    }, "Clone Project"), ' ', "to clone this project and run from the beginning for the new project only. Your current project will not re-run, and will still be available to explore."), __jsx("li", null, "Click", __jsx(Text, {
      code: true
    }, "Cancel"), ' ', "to close this popup. You can then choose to discard the changed settings in your current project.")))
  }), runQCAuthorized && __jsx("p", null, "This might take several minutes. Your navigation within Trailmaker will be restricted during this time. Do you want to start?"));
};
QCRerunDisabledModal.defaultProps = {
  visible: true,
  onFinish: function onFinish() {}
};
export default QCRerunDisabledModal;